// removed by extract-text-webpack-plugin
module.exports = {"character-count":"_1fLU3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TextareaWithCharacterCount/TextareaWithCharacterCount.scss
// module id = ./src/components/TextareaWithCharacterCount/TextareaWithCharacterCount.scss
// module chunks = 4